// extracted by css-extract-rspack-plugin
export default {"body":"Description-module__body__jenz3"};